import { render, staticRenderFns } from "./modalEvento.vue?vue&type=template&id=067568b2"
import script from "./modalEvento.vue?vue&type=script&lang=js"
export * from "./modalEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports